import type { UiNode, UiNodeAnchorAttributes } from "@ory/kratos-client";
import type React from "react";

interface Props {
	node: UiNode;
	attributes: UiNodeAnchorAttributes;
}

export const NodeAnchor: React.FC<Props> = ({ attributes }) => {
	return (
		<button
			type="button"
			data-testid={`node/anchor/${attributes.id}`}
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				window.location.href = attributes.href;
			}}
		>
			{attributes.title.text}
		</button>
	);
};
